module.exports = __webpack_public_path__ + "static/media/tc.c61ef06a.svg";